<template>
    <div class="gofixInput gofixTimeInput" v-bind:class="{gofixInputHasDesc:desc,gofixInputError : (required && !value && blurInput), gofixInputDisable:disabled, gofixInputHasValue:value, gofixInputNoLabel:!label}">
        <div class="mainInput">
            <vue-timepicker
                    v-bind:class="{openTimePicker:openTimePicker}"
                    @change="handleInput"
                    @open="openTimePickerFn"
                    @close="closeTimePickerFn"
                    :disabled="disabled"
                    class="inputTimeHeight"
                    placeholder=" "
                    :key="internalKey"
                    :value="value"></vue-timepicker>
            <div class="label">{{label}}<span class="iconRequired" v-if="showIconRequired && required">*</span></div>
        </div>
        <p class="desc" v-if="desc" v-html="desc"></p>
        <slot name="gofixInput:text:after-desc"></slot>
    </div>
</template>

<script>
    import VueTimepicker from 'vue2-timepicker';
    import 'vue2-timepicker/dist/VueTimepicker.css';
    export default {
        name: "input-time",
        components: {
            VueTimepicker
        },
        props: {
            desc: {
                type: String,
                required: false,
                default: () => null
            },
            label: {
                type: String,
                required: false,
                default: () => "Label"
            },
            value: {
                default: () => "00:00"
            },
            showIconRequired: {
                type: Boolean,
                required: false,
                default: () => false
            },
            required: {
                type: Boolean,
                required: false,
                default: () => false
            },
            disabled: {
                type: Boolean,
                default: false
            },
            internalKey: {
                type: String,
                default: ''
            }
        },

        data() {
            return {
                blurInput:false,
                openTimePicker:false,
            }
        },
        watch: {


        },
        created(){

        },
        methods: {
            handleInput (e) {
                this.$emit("input", e.displayTime);
                this.$emit("change", e);
            },
            openTimePickerFn () {
                this.openTimePicker = true;
                this.blurInput = true;
            },
            closeTimePickerFn () {
                this.openTimePicker = false;
            }
        }
    }
</script>

<style scoped>

</style>
